const ScorePathSkeleton = () => {
  return (
    <>
      <circle
        fill="rgba(0,0,0,0)"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="100"
        cy="100"
        r="90"
        stroke="#B8B8B8"
        opacity="1"
        pathLength="1"
        strokeDashoffset="0px"
        strokeDasharray="0.15px 1px"
        style={{ transform: 'rotate(180deg)', transformOrigin: '100px 100px' }}
        transform-origin="100px 100px"
      />
      <circle
        fill="rgba(0,0,0,0)"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="100"
        cy="100"
        r="90"
        stroke="#B8B8B8"
        opacity="1"
        pathLength="1"
        strokeDashoffset="0px"
        strokeDasharray="0.089px 1px"
        style={{ transform: 'rotate(243deg)', transformOrigin: '100px 100px' }}
        transform-origin="100px 100px"
      />
      <circle
        fill="rgba(0,0,0,0)"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="100"
        cy="100"
        r="90"
        stroke="#B8B8B8"
        opacity="1"
        pathLength="1"
        strokeDashoffset="0px"
        strokeDasharray="0.091px 1px"
        style={{ transform: 'rotate(284deg)', transformOrigin: '100px 100px' }}
        transform-origin="100px 100px"
      />
      <circle
        fill="rgba(0,0,0,0)"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="100"
        cy="100"
        r="90"
        stroke="#B8B8B8"
        opacity="1"
        pathLength="1"
        strokeDashoffset="0px"
        strokeDasharray="0.092px 1px"
        style={{ transform: 'rotate(327deg)', transformOrigin: '100px 100px' }}
        transform-origin="100px 100px"
      />
    </>
  )
}

export default ScorePathSkeleton
